// extracted by mini-css-extract-plugin
export default {"button":"_1cheHu2s","startIcon":"_3QTRIM5a","endIcon":"bgPcNmEE"};